const vlmInstructons = {
  instruction: "Instrucción",
  AddNewInstruction: "Agregar nueva instrucción",
  location: "Ubicación",
  rule: "Regla",
  documentType: "Tipo de documento",
  tags: "Etiquetas",
  actions: "Acciones",
  cancel: "Cancelar",
  save: "Guardar",
  InstructionLocation: "Ubicación de instrucción",
  InstructionRule: "Regla de instrucción",
  InstructionDocumentType: "Tipo de documento de instrucción",
  InstructionTags: "Etiquetas de instrucción",
  AddInstruction: "Agregar instrucción",
  NoInstructionsFound: "No se encontraron instrucciones",
  Loading: "Cargando",
  instructionUpdatedSuccessfully: "Instrucción actualizada exitosamente",
  instructionCreatedSuccessfully: "Instrucción creada exitosamente",
  fieldIgnoredSuccessfully: "Campo ignorado exitosamente",
  create: "Crear",
  edit: "Editar",
  fieldName: "Nombre del campo",
  tableName: "Nombre de la tabla",
  noInstructions: "No se encontraron instrucciones",
  ignoreField: "Ignorar campo",
  instruction_already_defined:
    "Instrucción ya definida, por favor elimine todas las instrucciones",
  instructionDeletedSuccessfully: "Instrucción eliminada exitosamente",
  location_is_required: "La ubicación es requerida",
  rule_is_required: "La regla es requerida",
  tags_are_required: "Las etiquetas son requeridas",
  instruction_already_ignored: "Instrucción ya ignorada",
  ignored: "Ignorado",
  ignored_status: "Estado de ignorados",
  location_hint:
    "Una ubicación le indica al modelo dónde buscar el valor del campo en el documento.",
  rule_hint:
    "Una regla es una guía a nivel de campo que se escribe para un campo específico. Le indica al modelo cómo encontrar, interpretar y devolver el valor de ese campo.",
  general: "General",
  tagWise: "Etiqueta sabia",
  extraction_rules: "Reglas de extracción",
  add_new_rule: "Agregar Nueva Regla",
  field_name: "Nombre del campo",
  scope: "¿Cuándo se aplicará la regla de extracción?",
  field_extraction_status: "Estado de Extracción del Campo",
  all_documents: "Todos los documentos",
  preview_rules_by_scope: "Previsualizar reglas por alcance",
  preview_rules_by_tag: "Previsualizar reglas por etiqueta",
  extract: "Extraer",
  exclude: "Excluir",
  delete: "Eliminar",
  no_rules_found: "No se encontraron reglas de extracción",
  add_new_rule_subtitle:
    "Define cómo la IA debe localizar y extraer un campo específico",
  all_documents_desc: "Aplicar a todos los documentos",
  document_type: "Tipo de documento",
  document_type_desc: "Aplicar al tipo de documento especificado",
  custom_tag: "Etiqueta personalizada",
  custom_tag_desc: "Aplicar al documento con palabra clave especificada",
  add: "Agregar",
  field_name_required: "El nombre del campo es obligatorio",
  rule_required: "La descripción visual es obligatoria",
  document_class_required: "El tipo de documento es obligatorio",
  tags_required: "Se requiere al menos una etiqueta",
  instruction_created_successfully: "Regla de extracción creada exitosamente",
  instruction_updated_successfully:
    "Regla de extracción actualizada exitosamente",
  instruction_deleted_successfully:
    "Regla de extracción eliminada exitosamente",
  something_went_wrong: "Algo salió mal",
  select_document_type: "Seleccionar tipo de documento",
  tags_placeholder: "Seleccione etiquetas existentes o cree nuevas etiquetas escribiendo el nombre de la etiqueta y presionando enter.",
  warningTemplate: {
    title: "Reglas de extracción activa contra cada campo",
    description:
      "Los campos sin reglas de extracción creadas para la etiqueta especificada se extraerán mediante reglas globales y por tipo de documento",
    descriptionDoc:
      "Los campos para los que no se hayan creado reglas de extracción para el tipo de documento especificado se extraerán mediante reglas globales.",
  },
  instruction_delete_title: `¿Está seguro de que desea eliminar esta instrucción?`,
  instruction_delete_description: `Eliminar el elemento lo quitará de su instrucción.`,
  instruciton_ignore_title: "¿Está seguro de que desea ignorar el campo?",
  instrunction_ignore_description:
    "Al ignorar este campo, se eliminarán todas sus reglas de extracción creadas y el campo se ignorará para todos los documentos.",
  update: "Actualizar",
  what_field_shold_extract: "¿Qué campo se debe extraer?",
  docType: "Tipo de documento",
  tag: "Etiqueta",
  emptyState: {
    titleTag:
      "Seleccione una etiqueta para ver qué reglas de extracción se aplican a cada campo.",
    descriptionTag:
      "Si un campo no tiene ninguna regla establecida para esta etiqueta, también verá reglas heredadas del tipo de documento o del nivel global.",
    titleDoc:
      "Seleccione un tipo de documento para ver qué reglas de extracción se aplican a cada campo.",
    descriptionDoc:
      "Si un campo no tiene ninguna regla establecida para este tipo de documento, también verá reglas heredadas del nivel global.",
  },
  select_tag: "Seleccionar etiqueta",
  scope_column: "Ámbito",
  edit_extraction_rule: "Editar regla de extracción",
  add_new_extraction_rule: "Agregar nueva regla de extracción",
  extraction_rule_dialog_subtitle:
    "Indique a Dost qué campo buscar, dónde se aplica la regla y cómo reconocerlo.",
  what_should_dost_do: "¿Qué debe hacer Dost con esto?",
  action_extract: "Extraer",
  action_extract_desc: "Leer el valor del documento",
  action_ignore: "Ignorar",
  action_ignore_desc: "Omitirlo en todas partes durante la extracción",
  where_does_rule_apply: "¿Dónde se aplica esta regla?",
  scope_all_documents: "Todos los documentos",
  scope_all_documents_desc: "Todos los documentos procesados por Dost",
  scope_document_type: "Tipo de documento",
  scope_document_type_desc: "p. ej. Factura, Orden de compra, etc.",
  scope_tagged_documents: "Documentos etiquetados",
  scope_tagged_documents_desc:
    "etiquetas como Google, Madrid, VendorID-0101, etc.",
  what_does_it_look_like: "¿Cómo se ve?",
  upload_image: "Subir imagen",
  write_manually: "Escribir manualmente",
  upload_hint:
    "Dost describe lo que ve y escribe la descripción visual por usted",
  generating_visual_description:
    "Generando la descripción visual con Dost AI...",
  visual_description_generated:
    "Descripción visual generada correctamente a partir de la imagen",
  visual_description: "Descripción visual",
  visual_description_placeholder_upload: "Descripción visual",
  visual_description_placeholder_manual:
    'Describa dónde se encuentra el valor y cómo reconocerlo, p. ej. "Código alfanumérico en negrita de 18 pt junto a la etiqueta Albarán en la parte superior derecha"',
  visual_description_hint_upload:
    "Las descripciones escritas en inglés funcionan mejor y puede editarlas para que sean más precisas",
  visual_description_hint_manual: "Escriba la descripción en inglés o",
  use_sample_prompt: "Usar mensaje de ejemplo",
  visual_description_max_length:
    "La descripción visual no puede superar los {{max}} caracteres",
  surpress_info:
    "Esta instrucción no se ejecutará porque está suprimida, ya que forma parte del ámbito {{scope}}.",
};

export default vlmInstructons;
